
/**
 * @imports
 */
import * as QuantumJS from './index.js';

// As globals
if ( !globalThis.webqit ) { globalThis.webqit = {}; }
Object.assign( globalThis.webqit, QuantumJS );
